import { useRouteError } from '@remix-run/react'
import { captureRemixErrorBoundaryError } from '@sentry/remix'

import styles from '~/components/error-page/index.module.css'

export const ErrorPage = () => {
  const error = useRouteError()
  captureRemixErrorBoundaryError(error)

  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <p className={styles.errorCode}>500</p>
        <h1 className={styles.title}>Internal Server Error</h1>
        <p className={styles.message}>
          We're sorry, but an unexpected error has occurred.
        </p>
        {process.env.NODE_ENV === 'development' && (
          <pre suppressHydrationWarning className={styles.errorDetails}>
            {JSON.stringify(error, null, 2)}
          </pre>
        )}
      </div>
    </main>
  )
}
